// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum DeleteFormResult {
	Success,
	Cancelled,
	Failure,
}

export type HandleDeleteForm = (formId: number, formName: string) => Promise<DeleteFormResult>;
